import React from 'react';

import { SEND_STARTED } from '@clutter/wt';

import { wt } from '@portal/initializers/wt';
import { IEventParams } from '@portal/types/wt/event';

export const TrackedLink: React.FC<{
  params: IEventParams;
  children: React.ReactElement<HTMLAnchorElement>;
}> = ({ params, children }) => {
  const wrappedOnClick = (event: React.MouseEvent, ...args: any[]) => {
    if (children.props.onClick) {
      children.props.onClick(event, ...args);
    }
    if (!event.defaultPrevented) {
      event.preventDefault();
      if (children.props.target === '_blank') {
        window.open(children.props.href);
      } else {
        wt.subscribe(SEND_STARTED, () => {
          window.location.assign(children.props.href);
        });
      }
      wt.track(params);
    }
  };
  return React.cloneElement(children, { onClick: wrappedOnClick });
};
